import React, { useEffect, useState } from "react";
import { Table, Modal, Button, Form, Breadcrumb } from "react-bootstrap";
import useReactRouter from "use-react-router";
// import * as _ from "lodash";
import {
  faExclamationCircle,
  faCheckCircle,
  faPlusCircle,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { COLOR_APP } from "../../constants";
import { useToasts } from "react-toast-notifications";
import { CREATE_SETTING, UPDATE_SETTING } from "../../graphql/setting/mutation";
import { useLazyQuery, useMutation } from "@apollo/client";
import { GET_SETTINGS } from "../../graphql/setting/query";

function SettingsTag() {
  const { addToast } = useToasts();
  const { history } = useReactRouter();

  const [shopSettings, setShopSettings] = useState([]);
  const [tagName, setTagName] = useState([]);
  const [tagColor, setTagColor] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState();
  const [getSettings, { data: shopSettingData }] = useLazyQuery(GET_SETTINGS, {
    fetchPolicy: "cache-and-network",
  });
  const [createSetting] = useMutation(CREATE_SETTING);
  const [updateSetting] = useMutation(UPDATE_SETTING);

  useEffect(() => {
    initSetting();
  }, []);

  const initSetting = async () => {
    let SHOP_ID = await localStorage.getItem("SHOP");
    await getSettings({
      variables: {
        where: {
          shop: SHOP_ID,
        },
        orderBy: "createdAt_ASC",
      },
    });
  };

  useEffect(() => {
    const initTags = () => {
      try {
        if (shopSettingData?.settings?.data?.length > 0) {
          const settings = shopSettingData.settings.data[0];
          const tags = settings?.tags;
          console.log('Raw tags data:', tags);
          
          setShopSettings(settings);
          
          if (!tags) {
            setTagName(['']);
            setTagColor(['']);
            return;
          }

          let parsedTags;
          if (typeof tags === 'string') {
            try {
              parsedTags = JSON.parse(tags);
            } catch (e) {
              console.error('Error parsing tags JSON:', e);
              console.error('Problematic tags string:', tags);
              parsedTags = { tagName: [''], tagColor: [''] };
            }
          } else {
            parsedTags = tags;
          }

          const tagNameArray = Array.isArray(parsedTags?.tagName) 
            ? parsedTags.tagName 
            : [parsedTags?.tagName || ''];
            
          const tagColorArray = Array.isArray(parsedTags?.tagColor) 
            ? parsedTags.tagColor 
            : [parsedTags?.tagColor || ''];
          
          console.log('Parsed tags:', { tagNameArray, tagColorArray });
          
          setTagName(tagNameArray.length ? tagNameArray : ['']);
          setTagColor(tagColorArray.length ? tagColorArray : ['']);
        } else {
          setTagName(['']);
          setTagColor(['']);
        }
      } catch (error) {
        console.error('Error in settings effect:', error);
        setTagName(['']);
        setTagColor(['']);
      }
    };

    initTags();
  }, [shopSettingData]);

  const _saveSetting = async () => {
    let SHOP_ID = await localStorage.getItem("SHOP");
    const countEmtyData = tagColor.filter((color) => color === "");
    if (countEmtyData.length > 0) {
      addToast(`ກະລຸນາເລືອກສີແທັກກ່ອນບັນທຶກ`, {
        appearance: "error",
        autoDismiss: true,
      });
      return;
    }
    let _tagData = {
      tagName,
      tagColor,
    };

    let tagNameIsEmpty = false;
    tagName.forEach((tName) => {
      if (!tName) tagNameIsEmpty = true;
    });
    if (tagName.length !== tagColor.length) {
      addToast(`ກະລຸນາເລືອກສີແທັກທຸກຊ່ອງກ່ອນບັນທຶກ`, {
        appearance: "error",
        autoDismiss: true,
      });
      return;
    }
    if (tagNameIsEmpty) {
      // errorSwal("ກະລຸນາເພີ່ມຊື່ແທັກກ່ອນບັນທຶກ")
      addToast(`ກະລຸນາເພີ່ມຊື່ແທັກກ່ອນບັນທຶກ`, {
        appearance: "error",
        autoDismiss: true,
      });
      return;
    }

    if (!shopSettings) {
      // let _addParams = new Settings({
      //     tags: JSON.stringify(_tagData),
      //     shop: { id: SHOP_ID }
      // })
      // await DataStore.save(new Settings(_addParams));
      // successSwal('ຕັ້ງຄ່າແທັກສໍາເລັດ')
      await createSetting({
        variables: {
          data: {
            tags: JSON.stringify(_tagData),
            shop: SHOP_ID,
          },
        },
      });
      addToast("ຕັ້ງຄ່າແທັກສໍາເລັດ", {
        appearance: "success",
        autoDismiss: true,
      });
    } else {
      // await DataStore.save(
      //     Settings.copyOf(shopSettings[0], updated => {
      //         updated.tags = JSON.stringify(_tagData);
      //     })
      // );
      // successSwal('ຕັ້ງຄ່າແທັກສໍາເລັດ')
      await updateSetting({
        variables: {
          where: {
            id: shopSettings.id,
          },
          data: {
            tags: JSON.stringify(_tagData),
            shop: SHOP_ID,
          },
        },
      });
      addToast("ຕັ້ງຄ່າແທັກສໍາເລັດ", {
        appearance: "success",
        autoDismiss: true,
      });
    }
  };

  const _addNewTag = () => {
    let _tagName = [...tagName];
    let _tagColor = [...tagColor];

    if (_tagName.length != 0 && !_tagName[_tagName.length - 1]) {
      addToast(`ກະລຸນານໍາໃຊ້ແທັກທີ່ເພີ່ມກ່ອນຫນ້ານີ້`, {
        appearance: "error",
        autoDismiss: true,
      });
      return;
    }
    _tagName.push("");
    _tagColor.push("");
    setTagName(_tagName);
    setTagColor(_tagColor);
  };

  const _removeTag = async () => {
    let _tagName = [...tagName];
    let _tagColor = [...tagColor];

    _tagName.splice(deleteIndex, 1);
    _tagColor.splice(deleteIndex, 1);
    setTagName(_tagName);
    setTagColor(_tagColor);
    let _tagData = {
      tagName: _tagName,
      tagColor: _tagColor,
    };
    // await DataStore.save(
    //     Settings.copyOf(shopSettings[0], updated => {
    //         updated.tags = JSON.stringify(_tagData);
    //     })
    // );
    await updateSetting({
      variables: {
        where: {
          id: shopSettings.id,
        },
        data: {
          tags: JSON.stringify(_tagData),
        },
      },
    });
    setShowDeleteModal(false);
    // successSwal('ຕັ້ງຄ່າແທັກສໍາເລັດ')
    addToast("ຕັ້ງຄ່າແທັກສໍາເລັດ", {
      appearance: "success",
      autoDismiss: true,
    });
  };

  return (
    <div style={{ marginTop: "2.5em", padding: '1em .55em'}}>
      <Breadcrumb>
        <Breadcrumb.Item onClick={() => history.replace("/settings")}>
          ຕັ້ງຄ່າ
        </Breadcrumb.Item>
        <Breadcrumb.Item active>ຕັ້ງຄ່າແທັກ</Breadcrumb.Item>
      </Breadcrumb>
      <div style={{ height: 10 }} />
      <div className="w-100">
          <p style={{ margin: 0, fontSize: 20, fontWeight: "bold" }}>
            ຄໍາແນະນໍາການຕັ້ງຄ່າ
          </p>
          <p style={{ margin: 0, fontSize: 14 }}>
            1. ​ຕັ້ງຄ່າແທັກທີ່ຕ້ອງການຕິດຕາມລູກຄ້າທີ່ມາຊື້ສິນຄ້າ
            ເພື່ອແຍກປະເພດລູກຄ້າເຊັ່ນ: ລູກຄ້າປະຈໍາ, ລູກຄ້າປະພຶດດີ, ລູກຄ້າມາກໍ່ກວນ
            ແລະ ອື່ນໆ
          </p>
          <p style={{ margin: 0, fontSize: 14 }}>
            2. ສາມາດກໍານົດສີໃຫ້ປະເພດຂອງລູກຄ້າເພື່ອສະດວກໃນການຮັບຮູ້
          </p>
        </div>
      <div className="row">
        <div className="col-12">
          <button
            className="btn btn-app col-2 hoverme"
            style={{
              float: "right",
              background: COLOR_APP,
              color: "#fff",
            }}
            onClick={_addNewTag}
          >
            {" "}
            <FontAwesomeIcon icon={faPlusCircle} /> ເພີ່ມແທັກ
          </button>
          <Table responsive className="staff-table-list borderless table-hover">
            <thead style={{ background: COLOR_APP, color: "#fff" }}>
              <tr>
                <th>ລ/ດ</th>
                <th>ຊື່ແທັກ</th>
                <th>ສີແທັກ</th>
                <th>ຈັດການ</th>
              </tr>
            </thead>
            <tbody style={{ background: "#eee" }}>
              {tagName.map((tag, index) => (
                <tr key={"tag" + index}>
                  <td>{index + 1}</td>
                  <td>
                    <Form.Control
                      onChange={(e) => {
                        let _tagName = [...tagName];
                        _tagName[index] = e.target.value;
                        setTagName(_tagName);
                      }}
                      type="text"
                      placeholder="ຊື່ແທັກ..."
                      value={tagName[index] || ""}
                    />
                  </td>
                  <td>
                    <Form.Control
                      as="select"
                      name="selectStatus"
                      custom
                      onChange={(e) => {
                        let _tagColor = [...tagColor];
                        _tagColor[index] = e.target.value;
                        setTagColor(_tagColor);
                      }}
                      style={{
                        margin: 0,
                        padding: 5,
                        background: tagColor[index] || "",
                        color: tagColor[index] ? "#fff" : "#b1b1b1",
                      }}
                      value={tagColor[index] || ""}
                    >
                      <option value={""} disabled>
                        {" "}
                        ເລືອກສີ
                      </option>
                      <option value={"red"}> ສີແດງ</option>
                      <option value={"black"}>ສີດໍາ</option>
                      <option value={"green"}>ສີຂຽວ</option>
                      <option value={"purple"}>ສີມ້ວງ</option>
                      <option value={"orange"}>ສີສົ້ມ</option>
                      <option value={"blue"}>ສີຟ້າ</option>
                    </Form.Control>
                  </td>
                  <td className="row" style={{ margin: 0 }}>
                    <button
                      className="btn hoverme btn-outline-primary col"
                      style={{ borderColor: COLOR_APP, color: COLOR_APP }}
                      onClick={_saveSetting}
                    >
                      <FontAwesomeIcon icon={faCheckCircle} /> ບັນທຶກ
                    </button>
                    <div style={{ width: 5 }} />
                    <button
                      className="btn hoverme btn-danger col"
                      onClick={() => {
                        setDeleteIndex(index);
                        setShowDeleteModal(true);
                      }}
                    >
                      <FontAwesomeIcon icon={faTrash} /> ລຶບ
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
        
      </div>

      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
        <Modal.Header closeButton>
          <div>ຢືນຢັນການລຶບ</div>
        </Modal.Header>
        <Modal.Body
          style={{
            padding: 24,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
          }}
        >
          <FontAwesomeIcon
            icon={faExclamationCircle}
            style={{ fontSize: 90, color: "orange" }}
          />
          <br />
          <h5>ທ່ານຕ້ອງການທີ່ຈະລຶບແທັກນີ້ແທ້ບໍ່?</h5>
        </Modal.Body>
        <Modal.Footer
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Button
            variant="outline-dark"
            className="btn btn-app hoverme"
            style={{ width: 150 }}
            onClick={() => setShowDeleteModal(false)}
          >
            ກັບຄືນ
          </Button>
          <div style={{ width: 24 }} />
          <button
            className="btn btn-app hoverme"
            style={{
              float: "left",
              background: "red",
              color: "#fff",
              width: 150,
            }}
            onClick={() => _removeTag()}
          >
            ລຶບ
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default SettingsTag;
